<template>
  <div style="width: 100%; margin: 0 auto; background: #f5f5f5; margin-top: 0.7rem" v-loading="Loading">
    <div class="container">
      <div
        style="border-radius: 8px;width: 100%;height: 62px;background: #FFF;margin-bottom: 20px;padding-left: 10px; color: #333333; font-weight: 400; font-size: 20px;display: flex;align-items: center;column-gap: 40px;padding-left: 16px;cursor: pointer;">
        <div :style="[{ color: index == 0 ? '#2978FF' : '#333333' }]" @click="btn(0)"><span>活动列表</span></div>
        <div :style="[{ color: index == 1 ? '#2978FF' : '#333333' }]" @click="btn(1)"><span>活动公告</span></div>
      </div>
      <a class="container_body" @click="showInfo(item)"
        :style="{ '--background': item.status == 0 || new Date(item.stopTime).getTime() < new Date().getTime() ? '#333434' : '#2b79ff' }"
        v-for="( item, index ) in  list " :key="index">
        <img :src="item.showImage" />
        <div class="dataStatus" v-if="item.activityType != 4">
          {{ item.status == 0 || new Date(item.stopTime).getTime() < new Date().getTime() ? '往期活动' : '活动进行中' }} </div>
            <div class="title">
              <div class="flex">
                <div style="height: 32px;line-height: 32px;font-size: 14px; font-weight: 700;">{{ item.title }}</div>
                <div>
                  <div style="color: rgba(0, 0, 0, 0.6);">
                    {{ getTime(item) }}
                  </div>
                </div>
              </div>
              <div v-if="item.activityType != 4">
                <el-alert v-show="!isOver(item)" :title="`距离截至还有${getDay(item)}天`" type="warning"
                  style="color: #ff8a43;background: #ffdfcc;font-weight: 700;" :closable="false" />
                <el-alert v-show="isOver(item)" title="已结束" type="info" :closable="false" />
              </div>
            </div>
      </a>
      <div v-if="list.length"
        style="padding-bottom: 30px;display: flex;justify-content: flex-end;align-items: center;width: 100%;">
        <el-pagination :total="queryParams.total" v-model:page="queryParams.pageNum" @current-change="paginationChange"
          v-model:limit="queryParams.pageSize" />
      </div>
      <div v-if="!list.length" style="display: flex;justify-content: center;width: 100%;">
        <el-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import { ref, computed } from "vue";
import { ElMessage } from "element-plus";
document.title = "标识山西-活动";
const list: any = ref([]);
const index = ref(0);
import { Axios } from "../../assets/js/ls_com_axios.js";
const Loading = ref(false);
const router = useRouter();
const queryParams = ref({
  total: 0,
  pageNum: 1,
  pageSize: 10,
  listType: 1,
});
const btn = (index_: number) => {
  index.value = index_;
  queryParams.value.listType = index_ == 0 ? 1 : 2;
  getList()
}
const getList = function () {
  let params = {
    pageNum: queryParams.value.pageNum,
    pageSize: queryParams.value.pageSize,
    publishStatus: 1,
    listType: queryParams.value.listType,
    orderByColumn: 'sortCode'
  };
  Loading.value = true;
  Axios("get", "/system/activity/list", params, false, function (res) {
    if (res.data.code == 200) {
      list.value = res.data.rows;
      queryParams.value.total = res.data.total;
    } else {
      ElMessage.error(res.data.message || "网络错误，请稍后重试");
    }
    Loading.value = false;
  });
};
const paginationChange = (num: number) => {
  queryParams.value.pageNum = num;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  getList()
}
const getTime = function (item: any) {
  if (item.activityType == 4) {
    return item.createTime.split(" ")[0]
  }
  const endTime = new Date(item.stopTime)
  const now = new Date()
  if (endTime.getTime() < now.getTime()) {
    return '已结束'
  } else {
    return item.startTime.replace('00:00:00', '') + '-' + item.stopTime.replace('00:00:00', '')
  }
}
const isOver = function (item: any) {
  const endTime = new Date(item.stopTime)
  const now = new Date()
  if (endTime.getTime() < now.getTime()) {
    return true;
  } else {
    return false;
  }
}
const getDay = function (item: any) {
  const endTime = new Date(item.stopTime)
  const now = new Date()
  return Math.ceil(((endTime.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));
}
const showInfo = (item: any) => {
  // console.log(item)
  if (item.activityType == 3) {
    router.push({
      path: "/drawList",
      query: { id: item.id }
    });
  } else {
    router.push({
      path: "/ShowActivity",
      query: { id: item.id, activityType: item.activityType }
    });
  }

}
getList()
</script>

<style lang="less" scoped>
.container {
  width: 12rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 0.4rem;
}

.container>a {
  width: 100%;
  display: block;
  margin-bottom: 0.4rem;
  border-radius: 10px;
  height: 410px;
  overflow: hidden;

  &:active {
    color: initial;
  }
}

.container>a img {
  width: 100%;
  height: 320px;
}

.container_body {
  position: relative;
  background-color: #fff;

  .title {
    padding: 0.12rem 0.16rem;
    border-radius: 0.12rem;
    transition: bottom 0.5s;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-end;

    .flex {
      display: flex;
      flex-direction: column;

      &>div {
        flex: 1;
      }
    }
  }

  .dataStatus {
    content: attr(data-status);
    position: absolute;
    top: 10px;
    left: 10px;
    display: block;
    border-radius: 5px;
    color: #fff;
    background-color: var(--background);
    padding: 5px 6px;

  }
}
</style>
